// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__3aOP-","title":"styles_title__sLEXC","subTitle":"styles_subTitle__275uU","radioGroup":"styles_radioGroup__2KfWn","information":"styles_information__3RmeY"};